var OpenNewTab = (function () {

    var $ = require('jquery');
    var self = {};

    self.init = function () {

        var $removeUrl = $('[data-remove-url]');

        if (App.Globals.$body.hasClass('main_links_in_new_tab')) {

            $('.block a:not([data-remove-url])').attr('target', '_blank');

        }

        if ($removeUrl.length > 0) {

            $removeUrl.each(function () {

                var $this = $(this);
                var href = $this.attr('href');
                var newUrl = href.replace(location.protocol + '//' + location.hostname, '');

                $this.attr('href', newUrl);

            });

        }

    };

    return self;

}());

module.exports = OpenNewTab;
